import { Player } from "@tezzro/player";
import { streamsApiInstance } from "@/shared/api/axios";
import { useAppDispatch } from "@/app/appStore";
import { updateIsPlaybackLoaded } from "@/entities/annotation";
import toast from "react-hot-toast";
import { PropsWithChildren, useCallback, useMemo } from "react";
import { useParams } from "react-router-dom";

const ANONYMOUS_MODE_KEY = "player-anonymous-mode";
const ANONYMOUS_MODE_MIGRATED_KEY = "player-anonymous-mode-migrated-v1";

export function PlayerProvider({ children }: PropsWithChildren) {
  const { storeKey = "" } = useParams();
  const dispatch = useAppDispatch();

  const initialState = useMemo(() => {
    if (!localStorage.getItem(ANONYMOUS_MODE_MIGRATED_KEY)) {
      localStorage.setItem(ANONYMOUS_MODE_KEY, "true");
      localStorage.setItem(ANONYMOUS_MODE_MIGRATED_KEY, "true");
    }
    const savedAnonymousMode = localStorage.getItem(ANONYMOUS_MODE_KEY);
    return {
      isAnonymousMode: savedAnonymousMode === "true",
    };
  }, []);

  const handleError = useCallback(
    (props: {
      message: string | (() => React.ReactElement | string | null);
    }) => {
      const message =
        typeof props.message === "function" ? props.message() : props.message;
      if (message) {
        toast.error(message);
      }
    },
    []
  );

  const handlePlaybackLoadedData = useCallback(() => {
    dispatch(updateIsPlaybackLoaded(true));
  }, [dispatch]);

  const handleAnonymousModeChange = useCallback((isAnonymous: boolean) => {
    localStorage.setItem(ANONYMOUS_MODE_KEY, String(isAnonymous));
  }, []);

  return (
    <Player.Root
      apiInstance={streamsApiInstance}
      timeUpdateStrategy="rAF"
      timeUpdateInterval={17}
      storeCode={storeKey}
      initialState={initialState}
      onError={handleError}
      onPlaybackLoadedData={handlePlaybackLoadedData}
      onAnonymousModeChange={handleAnonymousModeChange}
    >
      {children}
    </Player.Root>
  );
}
